module.exports = __webpack_public_path__ + "img/qrcode.3ad9d9d2.png";